import http from './http';
import { getApiRoute } from '../../config';

export default {
  async getStaticConfig(tenantId) {
    const deployment = window.location.hostname.includes('nsoft.app') ? 'CF' : 'NETLIFY';
    const route = `static_${deployment}`;
    const companyConfig = await http.get(
      `${getApiRoute(route, { productName: 'common' })}${getApiRoute('companyConfig', {
        productName: 'common',
      })}/${tenantId}.json`,
      {
        timeout: 7000,
      },
    );
    return JSON.parse(companyConfig.data);
  },
};
